import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import { ToDoService } from '../to-do.service';
import { UnitCustomizationRequest } from './unit-customization.model';

@Component({
  selector: 'cs-unit-customization-requests',
  standalone: false,
  templateUrl: './unit-customization-requests.component.html',
  styleUrls: ['./unit-customization-requests.component.scss']
})
export class UnitCustomizationRequestsComponent implements OnInit, OnDestroy {
  public unitCustomizationRequests: Array<UnitCustomizationRequest>;
  private $onDestroy = new Subject();
  public isLoading: boolean = true;
  @Output()
  public closeTodo = new EventEmitter<void>();

  constructor(private service: ToDoService, private router: Router) {}

  public ngOnDestroy(): void {
    this.$onDestroy.next(0);
    this.$onDestroy.complete();
  }

  public ngOnInit(): void {
    this.service
      .getUnitCustomizationRequests()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe(resp => {
        this.unitCustomizationRequests = resp;
        this.isLoading = false;
      });
  }

  public requestClick(request: UnitCustomizationRequest): void {
    this.router.navigate(
      ['/crm/customers/unit-customization-approval/approval'],
      {
        queryParams: { customizationId: request.customizationId }
      }
    );
    this.closeTodo.emit();
  }
}
